import React from 'react';
import AdminButton from './AdminButton';

function InstructorDashboard({
  t,
  user,
  openTrainingProgress,
  openStudyMaterials,
  openStudentDocuments,
  openTrainingCalendar,
}) {
  return (
    <div className="mx-auto max-w-7xl px-4 py-16">
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-8">
        {/* Training Progress FIRST */}
        <AdminButton
          title="Training Progress"
          description="View and manage student training progress across all sections"
          onClick={openTrainingProgress}
          icon="📊"
        />
        {/* Keep calendar and others next */}
        <AdminButton
          title="Training Calendar"
          description="View weekly calendar organized by trucks with student names and manage appointments"
          onClick={openTrainingCalendar}
          icon="📅"
        />
        <AdminButton
          title="Study Materials"
          description="Upload, manage, and organize training documents and resources"
          onClick={openStudyMaterials}
          icon="📖"
        />
        <AdminButton
          title="Student Documents"
          description="View and manage documents uploaded by students"
          onClick={openStudentDocuments}
          icon="📋"
        />
      </div>

    </div>
  );
}

export default InstructorDashboard;
